import React from "react";
import Nav from "../../components/Home/Nav";
import Slider from "../../components/Home/Slider";
import Footer from "../../components/Home/Footer";
import { Fade } from "react-awesome-reveal";
import {
  HiArrowRight,
  HiShieldCheck,
  HiStar,
  HiUsers,
  HiLightningBolt,
} from "react-icons/hi";
import { FaFacebook, FaWhatsapp, FaYoutube, FaTiktok } from "react-icons/fa";

function HomePage() {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Nav />
      <Slider />

      {/* Hero Content Section */}
      <section className="py-12 md:py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-[10px] font-black uppercase tracking-widest mb-6 border border-blue-100">
              <HiShieldCheck size={16} /> Elite Protection Services
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-slate-900 leading-[1.2] lg:leading-[1.1] mb-8 tracking-tight">
              Expert <span className="text-blue-600">Waterproofing</span>{" "}
              Solutions for Your Peace of Mind
            </h1>
            <div className="flex gap-4 mb-8">
              <div className="w-1.5 bg-blue-600 rounded-full"></div>
              <p className="text-base md:text-lg text-slate-600 leading-relaxed font-medium">
                At S.D Enterprises, we combine decades of field experience with
                cutting-edge chemical technology to deliver permanent
                waterproofing solutions. Protecting your structural integrity is
                our lifelong mission.
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              <a
                href="/homeServices"
                className="px-6 md:px-8 py-3.5 md:py-4 bg-blue-600 text-white rounded-2xl font-bold hover:bg-blue-700 transition-all shadow-xl shadow-blue-200 hover:-translate-y-1 flex items-center gap-2 text-sm md:text-base"
              >
                Explore Services <HiArrowRight />
              </a>
              <a
                href="#about-us"
                className="px-6 md:px-8 py-3.5 md:py-4 bg-white text-slate-700 border border-slate-200 rounded-2xl font-bold hover:bg-slate-50 transition-all hover:-translate-y-1 text-sm md:text-base"
              >
                Our Legacy
              </a>
            </div>
          </div>

          <div className="relative mt-8 md:mt-0">
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-blue-400/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-indigo-400/10 rounded-full blur-3xl"></div>
            <div className="glass p-3 md:p-4 rounded-[2rem] md:rounded-[2.5rem] border border-white/40 shadow-2xl relative z-10 overflow-hidden group bg-slate-900/5">
              <img
                src="https://res.cloudinary.com/dcmevbyyo/image/upload/v1785764751/f9f20638-c9d9-4493-b3d6-4db52538b81b_ckshhf.png"
                alt="Work in Progress"
                className="w-full h-[300px] md:h-[500px] object-contain rounded-[1.5rem] md:rounded-[2rem] transition-transform duration-1000 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section
        className="py-16 md:py-24 bg-white relative overflow-hidden"
        id="about-us"
      >
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="space-y-6 order-2 md:order-1">
            <p className="text-blue-600 font-black uppercase tracking-[0.2em] text-[10px] md:text-sm">
              Industry Authority
            </p>
            <h2 className="text-2xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              Experience the pinnacle of engineering excellence
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed font-medium">
              Founded on principles of durability and trust, S.D Enterprises has
              evolved from a small local specialist into a regional leader in
              structural protection. Our methodology combines rigorous
              scientific testing with precision application techniques that
              standard contractors simply cannot match.
            </p>
          </div>

          <div className="relative order-1 md:order-2">
            <div className="aspect-[4/3] md:aspect-square bg-slate-100 rounded-[2rem] md:rounded-[3rem] overflow-hidden group border border-slate-200/50 shadow-sm p-2 flex items-center justify-center">
              <img
                src="https://res.cloudinary.com/dcmevbyyo/image/upload/v1785764751/792060e5-fdac-4f82-8909-f23a8883a928_n3kofl.png"
                alt="Legacy"
                className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105 rounded-[1.5rem] md:rounded-[2.5rem]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Founder Message Section */}
      <section className="py-16 md:py-24 bg-slate-900 text-white relative overflow-hidden">
        {/* Decorative background element fixed for mobile */}
        <div className="absolute top-0 right-0 w-full md:w-[50%] h-full bg-blue-600/5 md:bg-blue-600/10 skew-x-0 md:skew-x-12 transform translate-x-0 md:translate-x-32 pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center relative z-10">
          <div className="relative group order-2 md:order-1">
            <div className="absolute inset-0 bg-blue-500/10 md:bg-blue-500/20 blur-[100px] rounded-full group-hover:bg-blue-500/30 transition-colors"></div>
            <img
              src="/founder.jpg"
              alt="Mr. Ganesh Dhakal - Founder"
              className="w-full max-w-sm md:max-w-md mx-auto aspect-square object-cover rounded-[2.5rem] md:rounded-[4rem] border-2 md:border-4 border-white/10 shadow-2xl transition-all duration-700 md:skew-y-2 hover:skew-y-0"
            />
          </div>

          <div className="space-y-6 md:space-y-8 order-1 md:order-2">
            <div className="w-12 md:w-16 h-1 bg-blue-500 rounded-full"></div>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-black tracking-tight leading-tight">
              "Our reputation is built on the water we keep out."
            </h2>
            <div className="space-y-2 md:space-y-4">
              <p className="text-lg md:text-xl font-bold text-blue-400">
                Mr. Ganesh Dhakal
              </p>
              <p className="text-blue-200/60 font-black uppercase tracking-widest text-[9px] md:text-xs">
                Architect & Founder
              </p>
            </div>
            <p className="text-base md:text-lg text-slate-300 leading-relaxed font-light italic opacity-90">
              I would like to extend my deepest gratitude to the people who have
              helped me become a waterproofing expert along the journey. This
              catalog introduces you to my company and my journey towards the
              waterproofing industry.
              <br></br>I hope to provide the best service for you and your
              company.
            </p>
            <div className="flex gap-4 flex-wrap">
              {[
                {
                  Icon: FaFacebook,
                  href: "https://www.facebook.com/profile.php?id=100029349942981",
                  title: "Facebook",
                  hover: "hover:bg-blue-600 hover:border-blue-400",
                },
                {
                  Icon: FaWhatsapp,
                  href: "https://wa.me/+9779801037595",
                  title: "WhatsApp",
                  hover: "hover:bg-emerald-600 hover:border-emerald-400",
                },
                {
                  Icon: FaYoutube,
                  href: "https://www.youtube.com/@sdenterprisesnepal",
                  title: "YouTube",
                  hover: "hover:bg-red-600 hover:border-red-400",
                },
                {
                  Icon: FaTiktok,
                  href: "https://tiktok.com",
                  title: "TikTok",
                  hover: "hover:bg-black hover:border-slate-700",
                },
              ].map((item, idx) => (
                <a
                  key={idx}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={item.title}
                  className={`w-10 h-10 md:w-12 md:h-12 bg-white/5 ${item.hover} rounded-xl md:rounded-2xl flex items-center justify-center transition-all border border-white/10 group`}
                >
                  <item.Icon
                    size={20}
                    className="group-hover:scale-110 transition-transform text-white"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default HomePage;
